import { cva } from 'class-variance-authority';

export const calendarItemVariants = cva(
  'bg-color-cold-lips-light-cardbg flex flex-col gap-2.5 items-start justify-start p-6 rounded-2xl w-full',
  {
    variants: {
      variant: {
        default: 'bg-cold-lips-light-cardbg',
        white: 'bg-white',
        math: 'bg-cold-lips-light-cardbg',
        english: 'bg-blue-chaos-light-cardbg',
        hobby_class: 'bg-magical-moonlight-d3',
        master_class: 'bg-magical-moonlight-d3',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const calendarPillVariants = cva(
  'bg-white flex items-center justify-center',
  {
    variants: {
      status: {
        upcoming: 'text-magical-moonlight-d2',
        holiday: 'text-magical-moonlight-d2',
        missed: 'text-fusion-red-dark',
        attended: 'text-underwater-fern-green-dark',
      },
      variant: {
        default: 'text-magical-moonlight-d2',
        math: 'text-magical-moonlight-d2',
        english: 'text-magical-moonlight-d2',
        hobby_class: 'bg-magical-moonlight-d2 text-magical-moonlight-white',
        master_class: 'bg-magical-moonlight-d2 text-magical-moonlight-white',
      },
    },
    defaultVariants: {
      status: 'upcoming',
      variant: 'default',
    },
  }
);

export const calendarDateTimeVariants = cva(
  'box-border flex items-center justify-between w-full px-3 lg:px-6 py-2 rounded-2xl md:gap-4',
  {
    variants: {
      variant: {
        default: 'bg-white text-magical-moonlight-d2',
        math: 'bg-white text-magical-moonlight-d2',
        english: 'bg-white text-magical-moonlight-d2',
        hobby_class: 'bg-magical-moonlight-d2 text-magical-moonlight-white',
        master_class: 'bg-magical-moonlight-d2 text-magical-moonlight-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const calendarTitleVariants = cva('font-semibold leading-6', {
  variants: {
    variant: {
      default: 'text-magical-moonlight-d2',
      math: 'text-magical-moonlight-d2',
      english: 'text-magical-moonlight-d2',
      hobby_class: 'text-magical-moonlight-white pl-2 md:pl-6',
      master_class: 'text-magical-moonlight-white',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
